export const locales = ["en", "ru", "zh"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeCookieName = "lk_locale";

export const localeNames: Record<Locale, string> = {
  en: "English",
  ru: "Русский",
  zh: "中文",
};

export function isLocale(value: string | undefined | null): value is Locale {
  return !!value && (locales as readonly string[]).includes(value);
}
